import PropTypes from 'prop-types';
//material-ui
import { styled } from '@mui/material/styles';

// third-party
import { SnackbarProvider } from 'notistack';

// project imports
import Loader from 'components/Loader';

// assets
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';

// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  '&.notistack-MuiContent-default': {
    background: theme.palette.primary.main
  },
  '&.notistack-MuiContent-error': {
    background: theme.palette.error.main
  },
  '&.notistack-MuiContent-success': {
    background: theme.palette.success.main
  },
  '&.notistack-MuiContent-info': {
    background: theme.palette.info.main
  },
  '&.notistack-MuiContent-warning': {
    background: theme.palette.warning.main
  }
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children }) {

  const iconSX = { marginRight: 8, fontSize: '1.15rem' };

  // if (snackbar === undefined) return <Loader />;

  return (
    <StyledSnackbarProvider
      // maxSnack={snackbar.maxStack}
      // dense={snackbar.dense}
      // iconVariant={
      //   snackbar.iconVariant === 'useemojis'
      //     ? {
      //         success: <CheckCircleOutlined style={iconSX} />,
      //         error: <CloseCircleOutlined style={iconSX} />,
      //         warning: <WarningOutlined style={iconSX} />,
      //         info: <InfoCircleOutlined style={iconSX} />
      //       }
      //     : undefined
      // }
      // hideIconVariant={snackbar.iconVariant === 'hide' ? true : false}
    >
      {children}
    </StyledSnackbarProvider>
  );
}

Notistack.propTypes = { children: PropTypes.any };
